import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../../../i18n/useLanguage";
import {
  AnyOrderItem,
  IncludedOptionalLineItem,
  OptionalLineItem,
} from "../../../../../stores/slices/cartSlice";
import { KeyValue } from "../../../../../ui/KeyValue/KeyValue";
import { PriceDisplay } from "../../../../../ui/PriceDisplay/PriceDisplay";

type AdditionalTireProps = {
  lineItem: IncludedOptionalLineItem | OptionalLineItem;
  orderItem: AnyOrderItem;
};

export const AdditionalItem: FunctionComponent<AdditionalTireProps> = ({
  lineItem,
}) => {
  const { t } = useTranslation();
  const [language] = useLanguage();
  const isInCart = "lineItemDetails" in lineItem;
  if (!isInCart) {
    return null;
  }
  return (
    <div className="grid grid-cols-4 py-2 items-center">
      <strong className="font-medium col-span-3 md:col-span-1">
        {lineItem.title[language] || lineItem.title["en"]}
      </strong>
      <KeyValue className="hidden md:block">
        <>{t("cart.price")}:</>
        <PriceDisplay>
          {Number(lineItem.price) / Number(lineItem.qty)}
        </PriceDisplay>
      </KeyValue>
      <KeyValue className="hidden md:block">
        <>{t("cart.quantity")}:</>
        <>{lineItem.qty}</>
      </KeyValue>
      <span className="flex gap-1 items-center justify-between">
        <KeyValue>
          <span className="hidden md:block">{t("cart.totalPrice")}:</span>
          <PriceDisplay>{lineItem.price}</PriceDisplay>
        </KeyValue>
      </span>
    </div>
  );
};
